import { PAYMENT_STATUS } from "../../../../Common/constants";

export const PAYMENT_RECEIVE_FILTER_KEY = "payment_receive_filter";
export const PAYMENT_LOG_FILTER_KEY = "payment_log_filter";

/**
 * Filters the Payment Received / Customer Payment Logs reports start out with. They are shown as
 * selected in the filter popover, so every request built for these reports has to carry them.
 */
export const defaultValuesFilterReport = {
  payment_status: [PAYMENT_STATUS.PENDING.value, PAYMENT_STATUS.PAID.value],
  channel_ids: [1],
};

/** Reads the popover filters persisted under `storageKey`, tolerating missing/corrupt entries. */
export const getStoredAdvanceFilters = (storageKey) => {
  try {
    const stored = localStorage.getItem(storageKey);
    return (stored ? JSON.parse(stored)?.advance_filters : null) || {};
  } catch (error) {
    console.error(`Failed to parse stored filters for ${storageKey}:`, error);
    return {};
  }
};

/**
 * Falls back to `defaultValuesFilterReport` for anything the user has not picked.
 *
 * Only use this on the paths that restore/initialise the filter (mount, stored filters), never on
 * the path that applies an explicit user selection — otherwise clearing a filter silently puts the
 * defaults back while the popover shows nothing selected.
 */
export const withDefaultReportFilters = (values = {}) => ({
  ...values,
  payment_status: values?.payment_status?.length ? values.payment_status : defaultValuesFilterReport.payment_status,
  channel_ids: values?.channel_ids?.length ? values.channel_ids : defaultValuesFilterReport.channel_ids,
});

/**
 * The default filters in the shape the report APIs expect, so the very first listing/export request
 * matches what the filter popover displays instead of going out unfiltered.
 */
export const getDefaultReportQueryParams = (storageKey) => {
  const { payment_status, channel_ids } = withDefaultReportFilters(getStoredAdvanceFilters(storageKey));
  return {
    payment_status: payment_status.join(","),
    channel_ids: channel_ids.join(","),
  };
};
